import createIcon from '../../createIcon';

/**
 * @component @name RoundedCorner
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTlIMjFWMjFIMTlWMTlaTTE5IDE3SDIxVjE1SDE5VjE3Wk0zIDEzSDVWMTFIM1YxM1pNMyAxN0g1VjE1SDNWMTdaTTMgOUg1VjdIM1Y5Wk0zIDVINVYzSDNWNVpNNyA1SDlWM0g3VjVaTTE1IDIxSDE3VjE5SDE1VjIxWk0xMSAyMUgxM1YxOUgxMVYyMVpNMTUgMjFIMTdWMTlIMTVWMjFaTTcgMjFIOVYxOUg3VjIxWk0zIDIxSDVWMTlIM1YyMVpNMjEgOEMyMSA1LjI0IDE4Ljc2IDMgMTYgM0gxMVY1SDE2QzE3LjY1IDUgMTkgNi4zNSAxOSA4VjEzSDIxVjhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RoundedCorner = createIcon('RoundedCorner', [
  [
    'path',
    {
      d: 'M19 19H21V21H19V19ZM19 17H21V15H19V17ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM3 5H5V3H3V5ZM7 5H9V3H7V5ZM15 21H17V19H15V21ZM11 21H13V19H11V21ZM15 21H17V19H15V21ZM7 21H9V19H7V21ZM3 21H5V19H3V21ZM21 8C21 5.24 18.76 3 16 3H11V5H16C17.65 5 19 6.35 19 8V13H21V8Z',
      key: 'ovm5wx',
    },
  ],
]);

export default RoundedCorner;
